import { lazyPage } from '../../utils/lazyPage';

const NFLBestPicksToday = lazyPage(() => import('./BestPicksToday'));
const NFLmoneyline = lazyPage(() => import('./NFLmoneyline/NFLmoneyline'));
const NFLspread = lazyPage(() => import('./NFLspread/NFLspread'));
const NFLtotal = lazyPage(() => import('./NFLtotal/NFLtotal'));
const NFLPlayerProps = lazyPage(() => import('./NFLPlayerProps/NFLPlayerProps'));

const nflRoutes = [
  {
    path: '/nfl/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <NFLBestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/nfl/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <NFLmoneyline {...params} />
  },
  {
    path: '/nfl/spread',
    label: 'Spreads',
    renderer: (params = {}) => <NFLspread {...params} />
  },
  {
    path: '/nfl/total',
    label: 'Totals',
    renderer: (params = {}) => <NFLtotal {...params} />
  },
  {
    path: '/nfl/player-props',
    label: 'Player Props',
    renderer: (params = {}) => <NFLPlayerProps {...params} />
  }
];

export default nflRoutes;
